import React from "react"

export default () => (
  <header>
    <img src='../../logo.png' />
    <h1>Igor <span>Đukić</span></h1>
  </header>
)
